export function handleConcomShopLoad(): void {
	const concomShopElement = document.getElementById('concom-shop');
	const shortFormSection = document.querySelector('section.short-form-component.secondary-bg') as HTMLElement;
	const footer = document.querySelector('footer#footer') as HTMLElement;
	
	if (!concomShopElement) return;

	
	const checkConcomShopLoaded = () => {
		if (concomShopElement.children.length > 0) {
			setTimeout(() => {
				concomShopElement.style.minHeight = '';
				concomShopElement.style.visibility = 'visible';
				
				if (shortFormSection) {
					shortFormSection.style.visibility = 'visible';
				}
				
				if (footer) {
					footer.style.visibility = 'visible';
				}
				
				clearInterval(loadCheckInterval);
			}, 1000);
		}
	};
	const loadCheckInterval = setInterval(checkConcomShopLoaded, 100);
}